import React, { useEffect, useState } from 'react';
import { Nav, NavItem, NavLink, TabContent, TabPane, Row, Col } from 'reactstrap';
import { withRouter } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';

type Props = {
  npr: string,
  inr: string,
  usd: string,
};

function Component({
  npr,
  inr,
  usd,
  history,
  nprInclusions,
  inrInclusions,
  usdInclusions,
}: Props) {
  const [activeTab, setActiveTab] = useState('3');

  const toggle = tab => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const navigateTo = (currency, tab) => () => {
    history.push({
      search: `?currency=${currency}`,
    });
    toggle(tab);
  };

  useEffect(() => {
    const {location: { search }} = history;
    if (search.indexOf('currency=npr') >= 0) toggle('1');
    if (search.indexOf('currency=inr') >= 0) toggle('2');
    if (search.indexOf('currency=usd') >= 0) toggle('3');
  },[]);

  return (
    <div>
      <Nav tabs className="price-tabs">
        <NavItem>
          <NavLink
            className={activeTab === '1' && 'active'}
            onClick={navigateTo('npr', '1')}
          >
            For Nepalis
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={activeTab === '2' && 'active'}
            onClick={navigateTo('inr', '2')}
          >
            For Indians
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={activeTab === '3' && 'active'}
            onClick={navigateTo('usd', '3')}
          >
            For Foreigners
          </NavLink>
        </NavItem>
      </Nav>
      <TabContent activeTab={activeTab} className="stat-content">
        <TabPane tabId="1">
          <Row>
            <Col sm="12">
              <div className="stat-content-holder">
                <div className="stat-price-wraper">
                  <h3 className="price">{npr}</h3>
                  <p>Flexible Cancellation Policy & Fair Prices</p>
                </div>
                <div className="stat-summary">
                  <ReactMarkdown source={nprInclusions} className="markdown-viewer" />
                </div>
              </div>
            </Col>
          </Row>
        </TabPane>
        <TabPane tabId="2">
          <Row>
            <Col sm="12">
              <div className="stat-content-holder">
                <div className="stat-price-wraper">
                  <h3 className="price">{inr}</h3>
                  <p>Flexible Cancellation Policy & Fair Prices</p>
                </div>
                <div className="stat-summary">
                  <ReactMarkdown source={inrInclusions} className="markdown-viewer" />
                </div>
              </div>
            </Col>
          </Row>
        </TabPane>
        <TabPane tabId="3">
          <Row>
            <Col sm="12">
              <div className="stat-content-holder">
                <div className="stat-price-wraper">
                  <h3 className="price">{usd}</h3>
                  <p>Flexible Cancellation Policy & Fair Prices</p>
                </div>
                <div className="stat-summary">
                  <ReactMarkdown source={usdInclusions} className="markdown-viewer" />
                </div>
              </div>
            </Col>
          </Row>
        </TabPane>
      </TabContent>
    </div>
  );
};

const TrekPriceAndInclusions = withRouter(Component);
export default TrekPriceAndInclusions;


// WEBPACK FOOTER //
// ./src/components/TrekDetail/DayOverview/TrekPriceAndInclusions.jsx